import { ref } from 'vue'

import { getI18n } from '@/plugins/i18n'
import { usePlanningStore } from '@/stores/planning.store'
import { useNotify } from '@/composables/notify'

export const useQrcode = () => {
  const getUUID = (qrcode) => {
    const uuidMatch = qrcode.match(/\?uuid=([a-z0-9-]+)/i)
    if (!uuidMatch || uuidMatch.length < 2) {
      throw new Error(`Unable to extract uuid from QR code decoded value: ${qrcode}`)
    }
    return uuidMatch[1]
  }

  return {
    getUUID
  }
}

export const useEquipmentQrScan = (onEquipmentFound) => {
  const i18n = getI18n()
  const planningStore = usePlanningStore()
  const { getUUID } = useQrcode()
  const { notifySuccess, notifyError, notifyWarning } = useNotify()

  const isScanning = ref(false)

  const scanUuidAsync = async(uuid) => {
    try {
      const equipment = (await planningStore.fetchEquipmentByUuidAsync(uuid))?.data[0]
      if (!equipment) {
        notifyWarning(i18n.t('warning.equipmentNotInList'))
      } else {
        notifySuccess(i18n.t('common.equipmentFound'))
        onEquipmentFound(equipment)
      }
    } catch (error) {
      console.error(error)
      notifyError(i18n.t('error.qrCodeNotFound'))
    } finally {
      isScanning.value = false
    }
  }

  const onQrcodeDetected = async(codes) => {
    await scanUuidAsync(getUUID(codes[0].rawValue))
  }

  const onQrcodeScanError = (error) => {
    console.error(error)
    notifyError(i18n.t('error.qrCodeNotFound'))
    isScanning.value = false
  }

  return { isScanning, scanUuidAsync, onQrcodeDetected, onQrcodeScanError }
}
